import { createNode, ZonedDateTimeDataType } from '@glueapp/graph-types';
import { Temporal } from '@js-temporal/polyfill';
import { fromZonedDateTime } from '../../utils/temporal';

export const NowZonedDateTime = createNode({
    id: 'Now (ZonedDateTime)',
    name: 'Now (ZonedDateTime)',
    description: 'Returns the current date and time with timezone information',
    aiDescription:
        'Takes a timezone string on the "Timezone" port and outputs the current ZonedDateTime on the "ZonedDateTime" port for that timezone.',
    category: 'Date & Time',
    color: '#3b82f6',
    integration: undefined,
    inPorts: {
        Timezone: { kind: 'string' },
    },
    outPorts: {
        ZonedDateTime: ZonedDateTimeDataType,
    },
    execute: function (input) {
        const zdt = Temporal.Now.zonedDateTimeISO(input.inPorts.Timezone);
        return { output: { ZonedDateTime: fromZonedDateTime(zdt) } };
    },
});
